var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 18.5,
    viewBox: "0 0 15.5 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu-sair",
    d: "M12,3.25a.75.75,0,0,1,.75.75v8a.75.75,0,0,1-1.5,0V4A.75.75,0,0,1,12,3.25ZM8.615,7.826A.75.75,0,0,1,8.429,8.87a6.25,6.25,0,1,0,7.142,0,.75.75,0,0,1,.858-1.23,7.75,7.75,0,1,1-8.858,0A.75.75,0,0,1,8.615,7.826Z",
    transform: "translate(-4.25 -3.25)",
    fill: "#640000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSair);
export default __webpack_public_path__ + "static/media/menu-sair.7f03836fba782f966c5b97d4990e668f.svg";
export { ForwardRef as ReactComponent };